import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';

import contactDetail from 'features/views/contactDetail';
import { equalOrThreeDashes, getCodelistPropById } from 'utils';

const { getOwnerValue } = contactDetail.utils;

export const ContactsTableRow = ({ contact = {}, solutionStates }) => {
	const {
		client = {},
		campaign = {},
		policy = {},
		solver = {},
		solutionStateId,
		idkRegionsCodelist,
		idkAgenciesCodelist,
	} = contact;

	const { fullName } = campaign;
	const { policyNo } = policy;
	const { businessName, firstname, surname, personIn, address = {} } = client;
	const { city, street, streetNo, zipCode } = address;

	const name = businessName ? businessName : `${surname || ''} ${firstname || ''}`.trim();
	const fullAddress = `${street || ''} ${streetNo || ''} ${zipCode || ''} ${city || ''}`.trim();

	return (
		<>
			<TableCell>
				<div>{equalOrThreeDashes(name)}</div>
				<div>{equalOrThreeDashes(personIn)}</div>
			</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(fullAddress)}</div>
				<div> {equalOrThreeDashes(fullName)}</div>
			</TableCell>
			<TableCell>{equalOrThreeDashes(policyNo)}</TableCell>
			<TableCell>{equalOrThreeDashes(policy.insurancePremium)}</TableCell>
			<TableCell>
				<div>{getOwnerValue(solver, idkAgenciesCodelist, idkRegionsCodelist, 'shortDescription')}</div>
				<div>
					{equalOrThreeDashes(getCodelistPropById(solutionStateId, solutionStates, 'shortDescription'))}
				</div>
			</TableCell>
		</>
	);
};

ContactsTableRow.propTypes = {
	contact: PropTypes.object,
	idkAgenciesCodelist: PropTypes.array,
	idkRegionsCodelist: PropTypes.array,
	solutionStates: PropTypes.array,
};

export default ContactsTableRow;
